import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  items: {}
}

const getActions = generateActions('fund/litelist/GET')

export const getLiteList = createAction(
  API_CONST,
  () => ({
    actions: getActions,
    url: 'funds/litelist'
  })
)

export default handleActions({
  [getActions[0]]: () => ({ ...initial }),
  [getActions[1]]: (state, { payload }) => ({ ...state, items: { ...state.items, ...payload } }),
}, initial)


// WEBPACK FOOTER //
// ./src/store/reducers/liteFundlist/index.js